<script setup>
import { computed } from 'vue';

const { rows, columns } = defineProps({
  rows: {
    type: Number,
    default: 5,
  },
  columns: {
    type: Number,
    default: 3,
  },
});

const tableData = computed(() => {
  const data = [];
  for (let i = 0; i < rows; i++) {
    const row = {};
    for (let j = 0; j < columns; j++) {
      row[`col-${j}`] = 'tes';
    }
    data.push(row);
  }
  return data;
});
</script>
<template>
  <DataTable :value="tableData" class="mt-5">
    <Column v-for="i in columns" :key="`col-${i}`" :field="`col-${i}`">
      <template #header>
        <Skeleton class="min-h-[1rem] min-w-[4rem] max-w-[8rem]" />
      </template>
      <template #body>
        <Skeleton class="min-h-[1rem] min-w-[3rem] max-w-[6rem]" />
      </template>
    </Column>
  </DataTable>
</template>
